import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import buildUrl from 'build-url';
import { sandbox } from '~content/main.json';

const VideoContainer = styled.div`
  max-width: 1100px;
  padding: 0 20px;
  margin: 4rem auto;
`;

const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: ${((9 / 16) * 100)}%;
`;

const VideoFrame = styled.iframe`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
`;

const VideoPlayerElement = ({ data }) => {
  const frameUrl = buildUrl(
    'https://d328y0m0mtvzqc.cloudfront.net/prod/powaEmbed.html',
    {
      queryParams: {
        org: 'bostonglobe',
        uuid: data._id,
        api: sandbox ? 'sandbox' : 'prod',
      },
    },
  );

  return (
    <VideoContainer className="content">
      <VideoWrapper
        className="video-wrapper"
      >
        <VideoFrame
          title="video"
          src={frameUrl}
        />
      </VideoWrapper>
    </VideoContainer>
  );
};

VideoPlayerElement.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
};

export default VideoPlayerElement;
